import ServerCodeModel from './ServerCodeModel.js';
import { getSubjectData, setSubjectData } from '../utils/storage';
import { isOnline } from '@/utils/network.js';
import ACTApiService from '../services/ACTApiService.js';
import localCasiData from '../data/casi.json';

class CasiModel {
    constructor(data = {}) {
        this.data = data;
        this.serverCodeModel = new ServerCodeModel();
        this.serverCodeModel.logType = 'InterviewerCASILog';
        this.actApiService = new ACTApiService();
    }

    async fetchData() {
        const subjectId = localStorage.getItem('subjectId');
        const subjectData = getSubjectData(subjectId);

        const cached = subjectData['casiData'];
        if (!isOnline() && cached && Array.isArray(cached.sections) && cached.sections.length > 0) {
            this.data = cached;
            console.log('Using local data:', this.data);
            return;
        }

        const existing = subjectData['casiData'];
        this.data = (existing && Array.isArray(existing.sections) && existing.sections.length > 0)
            ? existing
            : localCasiData;
        console.log('Fetched data:', this.data);
    }

    async saveData(data) {
        const subjectId = localStorage.getItem('subjectId');
        if (!data || !Array.isArray(data.sections)) {
            console.error('Attempting to save invalid CASI data structure');
            return;
        }
        setSubjectData(subjectId, 'casiData', data);
        this.data = data;
    }

    async submitData(data) {
        if (!data || !Array.isArray(data.sections)) {
            console.error('Attempting to submit invalid CASI data structure');
            return;
        }

        if(isOnline()) {
            await this.serverCodeModel.saveData(data);
            if (this.serverCodeModel.saveResult.ok) {
                console.log('Data saved successfully on server');
                
                await this.saveData(data);
                await this.syncVisitData();
                
                return;
            }
            console.error('Failed to save data:', this.serverCodeModel.saveResult.error);
        }
        await this.saveData(data);
        console.log('Data saved locally');
        
        await this.syncVisitData();
    }
    
    async syncVisitData() {
        try {
            const participantId = localStorage.getItem('currentParticipantId');
            const visitTypeId = localStorage.getItem('visitTypeId');
            const lGroupId = localStorage.getItem('actGroupId');
            const serverCode = localStorage.getItem('subjectId'); // Using subject/participantDisplayId as server code
            
            if (!participantId || !visitTypeId || !lGroupId || !serverCode) {
                console.warn('Missing required IDs for visit data sync', {
                    participantId,
                    visitTypeId,
                    lGroupId,
                    serverCode
                });
                return;
            }
            
            console.log('Syncing visit data for CASI task');
            
            const subjectData = JSON.parse(localStorage.getItem('subjectData') || '{}');
            const participantData = subjectData[serverCode] || {};
            
            if (!participantData['casiData']) {
                console.warn(`CASI data not found in localStorage for ${serverCode}`);
            } else {
                console.log('Found CASI data in localStorage', {
                    sections: participantData['casiData'].sections ? 
                        participantData['casiData'].sections.length : 0
                });
            }
            
            await this.actApiService.updateVisitData(lGroupId, participantId, visitTypeId, serverCode);
            console.log('Visit data synchronized successfully');
        } catch (error) {
            console.error('Failed to sync visit data:', error);
        }
    }
}

export default CasiModel;